import { type Content, ContentTypeEnum, type Locale, type TranslatableText } from "@/react/story/types";

const frDisplayLanguage = new Intl.DisplayNames([ "fr" ], { type: "language" });

class TranslationUtilsWrapper {

    getLocaleName(l: Locale) {
        try {
            return frDisplayLanguage.of(l.replace("_", "-"));
        } catch (e) {
            console.error(e);
        }

        return null;
    }

    getFixedLocales(locales: Locale[]): Locale[] {
        return locales
            .map(l => null === this.getLocaleName(l) ? null : l)
            .filter(l => null !== l);
    }

    get(text: TranslatableText | null | undefined, locale: Locale): string | null {
        if (text) {
            if (text[locale]) {
                return text[locale];
            }
            if (text["fr"]) {
                return text["fr"];
            }
            if (text["fr_FR"]) {
                return text["fr_FR"];
            }

            const keys = Object.keys(text);
            if (0 < keys.length) {
                return text[keys[0]];
            }
        }

        return null;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- accepts either a raw string or a dynamic translation map
    has(text: any, locale: Locale) {
        return (
            (
                "string" == typeof text
                && "" !== text.trim()
            )
            || (
                "object" === typeof text
                && !Array.isArray(text)
                && null !== text
                && "string" === typeof text[locale]
                && "" !== text[locale].trim()
            )
        );
    }

    isTranslatable(content: Content): boolean {
        return [
            ContentTypeEnum.TITLE,
            ContentTypeEnum.SUBTITLE,
            ContentTypeEnum.PARAGRAPH,
        ].includes(content.type);
    }

}

const TranslationUtils = new TranslationUtilsWrapper();

export default TranslationUtils;
